import { render, staticRenderFns } from "./SelectPaymentMethod.vue?vue&type=template&id=784ff032"
import script from "./SelectPaymentMethod.vue?vue&type=script&lang=js"
export * from "./SelectPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports